import { render, staticRenderFns } from "./catalog-layout.vue?vue&type=template&id=9e0f257a"
import script from "./catalog-layout.vue?vue&type=script&lang=js"
export * from "./catalog-layout.vue?vue&type=script&lang=js"
import style0 from "./catalog-layout.vue?vue&type=style&index=0&id=9e0f257a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports